// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings (/user_profile/profile_setting) */

.settings-page {
  max-width: 100%;
  color: #e5e5e5;
  padding-left: 40px;
  padding-right: 167px;
}

body.light_theme .settings-page {
  color: #0f172a;
}

.settings-page__hero {
  margin: 8px 0 22px;
}

.settings-page__title {
  margin: 0 0 15px;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.settings-page__subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #64748b;
}

.settings-page__card {
  background: #1e222a;
  border: 1px solid #f3f4f614;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.10);
  padding: 0px;
  margin-bottom: 40px;
}

body.light_theme .settings-page__card {
  background: #ffffff;
  border: 1px solid #E5E7EB;
}

.settings-page__card-head {
  padding: 24px;
  border-bottom: 1px solid #f3f4f60d;
}

body.light_theme .settings-page__card-head {
  border-bottom: 1px solid #F3F4F6;
}

.settings-page__card-title {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 600;
  color: #ebebeb;
}

body.light_theme .settings-page__card-title {
  color: #0f172a;
}

.settings-page__card-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #e6e6e6;
}

body.light_theme .settings-page__card-desc {
  color: #64748b;
}

.settings-page__rows {
  padding: 4px 0 8px;
}

.settings-page__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  border-bottom: 1px solid #f3f4f60d;
}

.settings-page__row:last-child {
  border-bottom: none;
}

body.light_theme .settings-page__row {
  border-bottom: 1px solid #F3F4F6;
}

.settings-page__row--last {
  border-bottom: 0;
}

.settings-page__row-main {
  display: flex;
  gap: 14px;
  min-width: 0;
}

.settings-page__row.border-none {
  border: none;
}

.settings-page__icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: #F9FAFB;
  border: none;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
}

.settings-page__row-title {
  font-size: 18px;
  font-weight: 600;
  color: #e8e8e8;
  margin-bottom: 4px;
}

body.light_theme .settings-page__row-title {
  color: #0f172a;
}

.settings-page__row-text {
  font-size: 14px;
  line-height: 1.55;
  color: #e2e2e2;
  max-width: 640px;
}

body.light_theme .settings-page__row-text {
  color: #64748b;
}

.settings-page__row-aside {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  justify-content: space-between;
}

.settings-page__value {
  font-size: 14px;
  font-weight: 500;
  color: #ebebeb;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

body.light_theme .settings-page__value {
  color: #0f172a;
}

.d-flex.profilebl_s {
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 75%;
  align-items: center;
  gap: 20px;
}


.settings-page__pill {
  border: 0;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: #2b313c;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, transform 0.05s ease;
}

body.light_theme .settings-page__pill {
  color: #0f172a;
  background: #f1f5f9;
}

.settings-page__pill:hover {
  opacity: 0.8;
}

.settings-page__pill:active {
  transform: translateY(1px);
}

.settings-page__avatar-wrap {
  width: 48px;
  min-width: 48px;
  height: 48px;
  border-radius: 999px;
  padding: 0;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

body.light_theme .settings-page__avatar-wrap {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.settings-page__avatar {
  width: 100%;
  height: 100%;
  min-width: 48px;
  min-height: 48px;
  border-radius: inherit;
  object-fit: cover;
  display: block;
  border: none;
}

@media (max-width: 767.98px) {
  .settings-page__row {
    align-items: stretch;
  }

  .settings-page__row-aside {
    justify-content: space-between;
    width: auto;
  }

  .settings-page__value {
    max-width: none;
    white-space: normal;
  }
}

/* —— Modals (profile settings) —— */

.settings-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 20%);
  /* Stay below react-hot-toast Toaster (\`App.js\` zIndex 2147483647); old value 9e9 hid all toasts behind modals. */
  z-index: 2147483000;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

body.light_theme .settings-modal-overlay {
  background-color: rgb(255 255 255 / 20%);
}

.settings-modal {
  position: relative;
  width: min(100%, 420px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: rgba(82, 82, 82, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  padding: 26px;
  color: #ffffff;
}

body.light_theme .settings-modal {
  background-color: rgb(255 255 255 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  border: 1px solid #E1E1E1;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12), 0 8px 16px rgba(15, 23, 42, 0.06);
  color: #0f172a;
}

.alert_setting .settings-modal__title {
  margin: 20px 36px 8px 24px;
}


.settings-modal.settings-modal--wide {
  padding: 0px;
}

.settings-modal--wide {
  width: min(100%, 539px);
}

.settings-modal--nickname {
  width: 606px;
  max-width: 100%;
}

.settings-modal--avatar {
  width: 1132px;
  max-width: 100%;
  padding: 26px;
}

.settings-modal--avatar .settings-modal__title {
  font-size: 28px;
  margin-bottom: 12px;
}

.settings-modal--avatar .settings-modal__info-banner {
  background: #f5ebda14;
  padding: 14px 16px;
}

body.light_theme .settings-modal--avatar .settings-modal__info-banner {
  background: #F5EBDA;
}

.settings-modal--avatar .settings-modal__tabs {
  gap: 8px;
  margin-top: 6px;
}

.settings-modal--avatar .settings-modal__tab {
  color: #6A7282;
  padding: 8px 18px;
}

.settings-modal__tabs--avatar-source {
  margin-bottom: 12px;
}

.settings-modal__avatar-live-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.settings-modal__avatar-live-preview-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}

body.light_theme .settings-modal__avatar-live-preview-label {
  color: #64748b;
}

.settings-modal__avatar-live-preview-frame {
  width: 112px;
  height: 112px;
  border-radius: 999px;
  overflow: hidden;
  border: 2px solid rgba(167, 139, 250, 0.45);
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .settings-modal__avatar-live-preview-frame {
  background: #f8fafc;
  border-color: rgba(167, 139, 250, 0.35);
}

.settings-modal__avatar-live-preview-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.settings-modal__avatar-upload {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 8px;
}

.settings-modal__avatar-upload-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.settings-modal__avatar-upload-zone {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.02);
  cursor: pointer;
  padding: 20px;
  transition: border-color 0.15s ease, background 0.15s ease;
}

body.light_theme .settings-modal__avatar-upload-zone {
  border: 2px dashed #cbd5e1;
  background: #f8fafc;
}

.settings-modal__avatar-upload-zone:hover {
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.05);
}

body.light_theme .settings-modal__avatar-upload-zone:hover {
  border-color: #dbdbdb;
  background: #fbfbfb;
}

.settings-modal__avatar-upload-preview {
  width: 100%;
  max-width: min(100%, 280px);
  min-height: 180px;
  max-height: min(50vh, 280px);
  height: auto;
  border-radius: 12px;
  object-fit: cover;
  display: block;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

body.light_theme .settings-modal__avatar-upload-preview {
  border: 2px solid #e2e8f0;
}

.settings-modal__avatar-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: #94a3b8;
}

body.light_theme .settings-modal__avatar-upload-placeholder {
  color: #64748b;
}

.settings-modal__avatar-upload-icon {
  font-size: 40px;
  color: #a78bfa;
  line-height: 1;
}

.settings-modal__avatar-upload-text {
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}

body.light_theme .settings-modal__avatar-upload-text {
  color: #334155;
}

.settings-modal__avatar-upload-hint {
  font-size: 12px;
  color: #94a3b8;
}

.settings-modal__avatar-upload-clear {
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: #94a3b8;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
  padding: 0;
}

body.light_theme .settings-modal__avatar-upload-clear {
  color: #64748b;
}

.settings-modal__avatar-upload-clear:hover {
  color: #dc2626;
}

.settings-modal--avatar .settings-modal__avatar-grid {
  gap: 16px;
  padding-top: 10px;
}

.settings-modal--avatar .settings-modal__avatar-cell {
  width: 70px;
  height: 70px;
  /* padding: 15px; */
  aspect-ratio: auto;
  margin: 0 auto;
}

.settings-modal--avatar .settings-modal__avatar-cell.is-selected {
  border-color: #a78bfa;
  box-shadow: 0 0 0 2px rgba(167, 139, 250, 0.25);
}

.settings-modal--avatar .settings-modal__footer {
  gap: 14px;
}

.settings-modal--avatar .settings-modal__btn {
  padding: 14px 18px;
}

.settings-modal__close {
  position: absolute;
  top: 16px;
  right: 18px;
  border: 0;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
}

body.light_theme .settings-modal__close {
  color: #64748b;
}

/* .settings-modal__close:hover {
  color: #0f172a;
  background: #f1f5f9;
} */

.settings-modal__title {
  margin: 0 36px 8px 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .settings-modal__title {
  color: #0f172a;
}

.settings-modal__subtitle {
  margin: 0 0 18px;
  font-size: 13px;
  line-height: 1.5;
  color: #94a3b8;
}

body.light_theme .settings-modal__subtitle {
  color: #666666;
}

.settings-modal.settings-modal--avatar {
  height: min(90vh, 760px);
  max-height: min(90vh, 760px);
  width: 539px;
  max-width: 100%;
}

.settings-modal__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 0px !important;
  width: 100%;
  margin-right: 0px;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.settings-modal__footer {
  display: flex;
  gap: 10px;
  margin-top: 35px;
  padding-top: 4px;
}

.settings-modal__label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 8px;
}

body.light_theme .settings-modal__label {
  color: #000000;
}

.settings-modal__input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.settings-modal__input {
  width: 100%;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 14px 40px 14px 14px;
  font-size: 14px;
  color: #ffffff;
  outline: none;
}

body.light_theme .settings-modal__input {
  background: #EDEEEF;
  border: none;
  color: #334155;
}

/* .settings-modal__input:focus {
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12);
} */

.settings-modal__input-clear {
  position: absolute;
  right: 10px;
  border: 0;
  background: none;
  padding: 0;
  color: #94a3b8;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  display: grid;
  place-items: center;
}

.settings-modal__input-clear:hover {
  color: #64748b;
}

.settings-modal__hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #999999;
  line-height: 1.45;
}

.settings-modal__warn {
  margin: 0 0 12px;
  font-size: 12px;
  color: #b45309;
  background: #fffbeb;
  border-radius: 10px;
  padding: 10px 12px;
}

.settings-modal__error {
  margin: 8px 0 0;
  font-size: 12px;
  color: #b91c1c;
}

.settings-modal__btn {
  border: 0;
  border-radius: 999px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.05s ease;
}

.settings-modal__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.settings-modal__btn--muted {
  width: 130px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

body.light_theme .settings-modal__btn--muted {
  background: #DDDDDD;
  color: #1e293b;
}

.settings-modal__btn--muted:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.15);
}

body.light_theme .settings-modal__btn--muted:hover:not(:disabled) {
  background: #d4d4d4;
}

.settings-modal__btn--primary {
  flex: 1.15 1;
  background: #303236;
  color: #ffffff;
}

body.light_theme .settings-modal__btn--primary {
  background: #2d2e32;
  color: #ffffff;
}

.settings-modal__btn--primary:hover:not(:disabled) {
  background: #404246;
}

body.light_theme .settings-modal__btn--primary:hover:not(:disabled) {
  background: #1a1b1e;
}

.settings-modal__btn--wide {
  flex: 1.25 1;
}

.settings-modal__info-banner {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
}

body.light_theme .settings-modal__info-banner {
  background: #faf6ef;
  border: none;
}

.settings-modal__info-banner p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #cbd5e1;
}

body.light_theme .settings-modal__info-banner p {
  color: #6b5f52;
}

.settings-modal__info-icon {
  flex: 0 0 auto;
  font-size: 18px;
  color: #a89076;
  margin-top: 1px;
}

.settings-modal__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.settings-modal__tab {
  border: 0;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
}

.settings-modal__tab.is-active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

body.light_theme .settings-modal__tab.is-active {
  background: #eef2f7;
  color: #0f172a;
}

.settings-modal__avatar-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 4px 0 8px;
}

.settings-modal__avatar-cell {
  aspect-ratio: 1;
  border-radius: 999px;
  border: 2px solid transparent;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

body.light_theme .settings-modal__avatar-cell {
  background: #e2e8f0;
}

.settings-modal__avatar-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.settings-modal__avatar-cell.is-selected {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.settings-modal__alerts-tabs {
  display: flex;
  gap: 32px;
  border-bottom: 1px solid #e2e8f0;
  margin: 4px 0 0;
  padding: 0px 24px 3px;
}

.settings-modal__alerts-tab {
  border: 0;
  background: none;
  padding: 10px 0 14px;
  font-size: 16px;
  font-weight: 500;
  color: #94a3b8;
  cursor: pointer;
  position: relative;
}

body.light_theme .settings-modal__alerts-tab {
  color: #6A7282;
}

.settings-modal__alerts-tab.is-active {
  color: #ffffff;
}

body.light_theme .settings-modal__alerts-tab.is-active {
  color: #1a202c;
}

.settings-modal__alerts-tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -3px;
  height: 3px;
  border-radius: 999px;
  background: #ffffff;
}

body.light_theme .settings-modal__alerts-tab.is-active::after {
  background: #1a202c;
}

.settings-modal__accordion {
  margin-top: 12px;
  padding: 0px 24px;
}

.settings-modal__acc-item {
  border-bottom: 1px solid #e2e8f0;
}

.settings-modal__acc-head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px 10px;
  border: 0;
  background: none;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  text-align: left;
}

body.light_theme .settings-modal__acc-head {
  color: #101828;
}

.settings-modal.settings-modal--wide.alert_setting {
  height: auto;
}

header ul.dropdown-menu li button.dropdown-item:active {
  background-color: transparent;
}

.settings-modal__acc-head i {
  font-size: 20px;
  color: #718096;
}

.settings-modal__acc-body {
  padding: 0 4px 12px;
}

.settings-modal__toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 10px;
  border-top: none;
  font-size: 15px;
}

.settings-modal__toggle-row:first-child {
  border-top: 0;
}

.settings-modal__switch {
  width: 44px;
  height: 24px;
  border-radius: 999px;
  border: 0;
  padding: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.1);
  transition: background 0.15s ease;
}

body.light_theme .settings-modal__switch {
  background: #e2e8f0;
}

.settings-modal__switch.is-on {
  background: #10b981;
}

body.light_theme .settings-modal__switch.is-on {
  background: #1e293b;
}

.settings-modal__switch-knob {
  position: absolute;
  top: 2px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease;
}

.settings-modal__switch.is-on .settings-modal__switch-knob {
  transform: translateX(18px);
}

.settings-modal--lang {
  width: min(100%, 520px);
}

.settings-modal__lang-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.settings-modal__lang-row {
  border-bottom: 1px solid #e2e8f0;
}

.settings-modal__lang-row:last-child {
  border-bottom: 0;
}

.settings-modal__lang-label {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  cursor: pointer;
  font-size: 14px;
  color: #ffffff;
}

body.light_theme .settings-modal__lang-label {
  color: #334155;
}

.settings-modal__lang-label input {
  accent-color: #0f172a;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Settings: General / Identity tabs */
.settings-page__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}

.settings-page__tab {
  border: 1px solid #54555740;
  color: #ffffff82;
  background: #1e222a75;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

body.light_theme .settings-page__tab {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
}

.settings-page__tab:hover {
  color: #ffffff;
  border-color: #54555740;
}

.settings-page__tab.is-active {
  color: #ffffff;
  background: #1e222a;
  border-color: #54555740;
}

body.light_theme .settings-page__tab.is-active {
  color: #0f172a;
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.settings-page__pill--link {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.settings-page__pill--link:hover {
  color: #fff;
}

/* Identity tab — status + actions */
.identity-section__row .identity-section__aside {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.identity-section__badge {
  min-height: 37px;
  padding: 4px 16px;
  display: flex;
  border-radius: 999px;
  background: #f1f5f9;
  white-space: nowrap;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
}

.identity-section__badge--ok,
.identity-section__badge--verified {
  background: #dcfce7;
  color: #166534;
}

.identity-section__badge--pending,
.identity-section__badge--under-review {
  background: #fef3c7;
  color: #a16207;
}

.identity-section__badge--in-progress {
  background: #dbeafe;
  color: #1d4ed8;
}

.identity-section__badge--bad,
.identity-section__badge--rejected {
  background: #fee2e2;
  color: #b91c1c;
}

.identity-section__badge--rekyc {
  background: #f3e8ff;
  color: #7e22ce;
}

.identity-section__badge--not-started {
  background: #e2e8f0;
  color: #475569;
}

/* @media (max-width: 767.98px) {
  .identity-section__row .identity-section__aside {
    width: 100%;
    justify-content: flex-start;
  }
} */


@media (max-width: 1440px) {

  .settings-page {
    padding-right: 35px;
  }

  .settings-page__title {
    font-size: 32px;
  }


}


@media (max-width: 1200px) {

  .settings-page {
    padding-right: 10px;
    padding-left: 20px;
  }

  .settings-modal--avatar .settings-modal__title {
    font-size: 24px;
  }

}


@media (max-width: 991px) {

  .settings-page {
    padding-right: 0px;
    padding-left: 0px;
  }

  body.light_theme .settings-page__card {
    border: none;
  }

  .settings-page__title {
    font-size: 24px;
  }

  .settings-page__card-title {
    font-size: 20px;
  }

  .settings-page__row-title {
    font-size: 16px;
  }

  .settings-page__card-head {
    padding: 5px 0px;
    border-bottom: none;
  }

  .settings-page__card {
    border: none;
    background: none;
    border-radius: 0px;
    box-shadow: none;
    padding: 0px;
    border-bottom: 1px solid #eeeeee21;
    margin-bottom: 20px;
  }

  body.light_theme .settings-page__card {
    border-bottom: 1px solid #eeeeee;
  }

  .settings-page__row {
    padding: 14px 0px;
    border-bottom: none;
  }

  .settings-page__row-text {
    display: none;
  }

  .settings-page__card-desc {
    display: none;
  }

}

@media (max-width: 767px) {

  .settings-page__title {
    font-size: 22px;
  }

  .settings-modal--nickname {
    width: 100%;
  }

  .settings-modal__avatar-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .settings-modal--avatar .settings-modal__avatar-cell {
    width: 60px;
    height: 60px;
  }

  .settings-modal--avatar .settings-modal__btn {
    padding: 8px 18px;
    font-size: 13px;
  }

  .d-flex.profilebl_s {
    width: 100%;
  }

  .settings-modal {
    height: min(100%, 65%);
  }

  .settings-modal__accordion {
    margin-top: 5px;
    padding: 0px 15px;
  }

  .settings-modal__switch {
    width: 38px;
    height: 20px;
  }

  .settings-modal__switch-knob {
    width: 16px;
    height: 16px;
  }

  .settings-modal__acc-head {
    font-size: 14px;
  }

  .settings-modal.settings-modal--wide.alert_setting {
    height: min(100%, 65%);
  }

  .settings-modal--avatar .settings-modal__title {
    font-size: 20px;
  }

  .settings-page__icon {
    display: none;
  }

  .settings-modal-overlay {
    padding: 0px;
    align-items: end;
  }

  .settings-modal {
    border-radius: 18px 18px 0px 0px;
    width: 100%;
  }

  .settings-modal.settings-modal--avatar {
    width: 100%;
  }

  .settings-modal__title {
    font-size: 20px;
  }

  .settings-modal__label {
    font-size: 14px;
  }

}

@media (max-width: 580px) {

  .identity-section__badge {
    min-height: 34px;
    padding: 4px 12px;
    font-size: 12px;
  }

  .settings-page__pill {
    padding: 7px 12px;
    min-height: 34px;
    font-size: 12px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SettingsPage/SettingsPage.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;;AAEpC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,iHAAiH;EACjH,mBAAmB;EACnB,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,0CAA0C;EAC1C,mBAAmB;EACnB,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,iFAAiF;EACjF,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;GAKG;;;AAGH;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;;AAGA;;EAEE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;AAEF","sourcesContent":["/* Settings (/user_profile/profile_setting) */\n\n.settings-page {\n  max-width: 100%;\n  color: #e5e5e5;\n  padding-left: 40px;\n  padding-right: 167px;\n}\n\nbody.light_theme .settings-page {\n  color: #0f172a;\n}\n\n.settings-page__hero {\n  margin: 8px 0 22px;\n}\n\n.settings-page__title {\n  margin: 0 0 15px;\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.settings-page__subtitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.settings-page__card {\n  background: #1e222a;\n  border: 1px solid #f3f4f614;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.10);\n  padding: 0px;\n  margin-bottom: 40px;\n}\n\nbody.light_theme .settings-page__card {\n  background: #ffffff;\n  border: 1px solid #E5E7EB;\n}\n\n.settings-page__card-head {\n  padding: 24px;\n  border-bottom: 1px solid #f3f4f60d;\n}\n\nbody.light_theme .settings-page__card-head {\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.settings-page__card-title {\n  margin: 0 0 6px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #ebebeb;\n}\n\nbody.light_theme .settings-page__card-title {\n  color: #0f172a;\n}\n\n.settings-page__card-desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #e6e6e6;\n}\n\nbody.light_theme .settings-page__card-desc {\n  color: #64748b;\n}\n\n.settings-page__rows {\n  padding: 4px 0 8px;\n}\n\n.settings-page__row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px;\n  border-bottom: 1px solid #f3f4f60d;\n}\n\n.settings-page__row:last-child {\n  border-bottom: none;\n}\n\nbody.light_theme .settings-page__row {\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.settings-page__row--last {\n  border-bottom: 0;\n}\n\n.settings-page__row-main {\n  display: flex;\n  gap: 14px;\n  min-width: 0;\n}\n\n.settings-page__row.border-none {\n  border: none;\n}\n\n.settings-page__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 14px;\n  background: #F9FAFB;\n  border: none;\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n}\n\n.settings-page__row-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e8e8e8;\n  margin-bottom: 4px;\n}\n\nbody.light_theme .settings-page__row-title {\n  color: #0f172a;\n}\n\n.settings-page__row-text {\n  font-size: 14px;\n  line-height: 1.55;\n  color: #e2e2e2;\n  max-width: 640px;\n}\n\nbody.light_theme .settings-page__row-text {\n  color: #64748b;\n}\n\n.settings-page__row-aside {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 0 auto;\n  justify-content: space-between;\n}\n\n.settings-page__value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ebebeb;\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nbody.light_theme .settings-page__value {\n  color: #0f172a;\n}\n\n.d-flex.profilebl_s {\n  align-items: center;\n  gap: 20px;\n  justify-content: space-between;\n  width: 75%;\n  align-items: center;\n  gap: 20px;\n}\n\n\n.settings-page__pill {\n  border: 0;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  background: #2b313c;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, transform 0.05s ease;\n}\n\nbody.light_theme .settings-page__pill {\n  color: #0f172a;\n  background: #f1f5f9;\n}\n\n.settings-page__pill:hover {\n  opacity: 0.8;\n}\n\n.settings-page__pill:active {\n  transform: translateY(1px);\n}\n\n.settings-page__avatar-wrap {\n  width: 48px;\n  min-width: 48px;\n  height: 48px;\n  border-radius: 999px;\n  padding: 0;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\nbody.light_theme .settings-page__avatar-wrap {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\n.settings-page__avatar {\n  width: 100%;\n  height: 100%;\n  min-width: 48px;\n  min-height: 48px;\n  border-radius: inherit;\n  object-fit: cover;\n  display: block;\n  border: none;\n}\n\n@media (max-width: 767.98px) {\n  .settings-page__row {\n    align-items: stretch;\n  }\n\n  .settings-page__row-aside {\n    justify-content: space-between;\n    width: auto;\n  }\n\n  .settings-page__value {\n    max-width: none;\n    white-space: normal;\n  }\n}\n\n/* —— Modals (profile settings) —— */\n\n.settings-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgb(0 0 0 / 20%);\n  /* Stay below react-hot-toast Toaster (`App.js` zIndex 2147483647); old value 9e9 hid all toasts behind modals. */\n  z-index: 2147483000;\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\nbody.light_theme .settings-modal-overlay {\n  background-color: rgb(255 255 255 / 20%);\n}\n\n.settings-modal {\n  position: relative;\n  width: min(100%, 420px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background-color: rgba(82, 82, 82, 0.20);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  padding: 26px;\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal {\n  background-color: rgb(255 255 255 / 20%);\n  -webkit-backdrop-filter: blur(5px);\n  backdrop-filter: blur(5px);\n  border: 1px solid #E1E1E1;\n  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12), 0 8px 16px rgba(15, 23, 42, 0.06);\n  color: #0f172a;\n}\n\n.alert_setting .settings-modal__title {\n  margin: 20px 36px 8px 24px;\n}\n\n\n.settings-modal.settings-modal--wide {\n  padding: 0px;\n}\n\n.settings-modal--wide {\n  width: min(100%, 539px);\n}\n\n.settings-modal--nickname {\n  width: 606px;\n  max-width: 100%;\n}\n\n.settings-modal--avatar {\n  width: 1132px;\n  max-width: 100%;\n  padding: 26px;\n}\n\n.settings-modal--avatar .settings-modal__title {\n  font-size: 28px;\n  margin-bottom: 12px;\n}\n\n.settings-modal--avatar .settings-modal__info-banner {\n  background: #f5ebda14;\n  padding: 14px 16px;\n}\n\nbody.light_theme .settings-modal--avatar .settings-modal__info-banner {\n  background: #F5EBDA;\n}\n\n.settings-modal--avatar .settings-modal__tabs {\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.settings-modal--avatar .settings-modal__tab {\n  color: #6A7282;\n  padding: 8px 18px;\n}\n\n.settings-modal__tabs--avatar-source {\n  margin-bottom: 12px;\n}\n\n.settings-modal__avatar-live-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.settings-modal__avatar-live-preview-label {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\nbody.light_theme .settings-modal__avatar-live-preview-label {\n  color: #64748b;\n}\n\n.settings-modal__avatar-live-preview-frame {\n  width: 112px;\n  height: 112px;\n  border-radius: 999px;\n  overflow: hidden;\n  border: 2px solid rgba(167, 139, 250, 0.45);\n  background: rgba(255, 255, 255, 0.04);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .settings-modal__avatar-live-preview-frame {\n  background: #f8fafc;\n  border-color: rgba(167, 139, 250, 0.35);\n}\n\n.settings-modal__avatar-live-preview-frame img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.settings-modal__avatar-upload {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 8px;\n}\n\n.settings-modal__avatar-upload-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.settings-modal__avatar-upload-zone {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  width: 100%;\n  border: 2px dashed rgba(255, 255, 255, 0.2);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.02);\n  cursor: pointer;\n  padding: 20px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\nbody.light_theme .settings-modal__avatar-upload-zone {\n  border: 2px dashed #cbd5e1;\n  background: #f8fafc;\n}\n\n.settings-modal__avatar-upload-zone:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody.light_theme .settings-modal__avatar-upload-zone:hover {\n  border-color: #dbdbdb;\n  background: #fbfbfb;\n}\n\n.settings-modal__avatar-upload-preview {\n  width: 100%;\n  max-width: min(100%, 280px);\n  min-height: 180px;\n  max-height: min(50vh, 280px);\n  height: auto;\n  border-radius: 12px;\n  object-fit: cover;\n  display: block;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .settings-modal__avatar-upload-preview {\n  border: 2px solid #e2e8f0;\n}\n\n.settings-modal__avatar-upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n  color: #94a3b8;\n}\n\nbody.light_theme .settings-modal__avatar-upload-placeholder {\n  color: #64748b;\n}\n\n.settings-modal__avatar-upload-icon {\n  font-size: 40px;\n  color: #a78bfa;\n  line-height: 1;\n}\n\n.settings-modal__avatar-upload-text {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\nbody.light_theme .settings-modal__avatar-upload-text {\n  color: #334155;\n}\n\n.settings-modal__avatar-upload-hint {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.settings-modal__avatar-upload-clear {\n  align-self: flex-start;\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 0;\n}\n\nbody.light_theme .settings-modal__avatar-upload-clear {\n  color: #64748b;\n}\n\n.settings-modal__avatar-upload-clear:hover {\n  color: #dc2626;\n}\n\n.settings-modal--avatar .settings-modal__avatar-grid {\n  gap: 16px;\n  padding-top: 10px;\n}\n\n.settings-modal--avatar .settings-modal__avatar-cell {\n  width: 70px;\n  height: 70px;\n  /* padding: 15px; */\n  aspect-ratio: auto;\n  margin: 0 auto;\n}\n\n.settings-modal--avatar .settings-modal__avatar-cell.is-selected {\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 2px rgba(167, 139, 250, 0.25);\n}\n\n.settings-modal--avatar .settings-modal__footer {\n  gap: 14px;\n}\n\n.settings-modal--avatar .settings-modal__btn {\n  padding: 14px 18px;\n}\n\n.settings-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  border: 0;\n  background: transparent;\n  font-size: 22px;\n  line-height: 1;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n}\n\nbody.light_theme .settings-modal__close {\n  color: #64748b;\n}\n\n/* .settings-modal__close:hover {\n  color: #0f172a;\n  background: #f1f5f9;\n} */\n\n.settings-modal__title {\n  margin: 0 36px 8px 0;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal__title {\n  color: #0f172a;\n}\n\n.settings-modal__subtitle {\n  margin: 0 0 18px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #94a3b8;\n}\n\nbody.light_theme .settings-modal__subtitle {\n  color: #666666;\n}\n\n.settings-modal.settings-modal--avatar {\n  height: min(90vh, 760px);\n  max-height: min(90vh, 760px);\n  width: 539px;\n  max-width: 100%;\n}\n\n.settings-modal__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 0px !important;\n  width: 100%;\n  margin-right: 0px;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.settings-modal__footer {\n  display: flex;\n  gap: 10px;\n  margin-top: 35px;\n  padding-top: 4px;\n}\n\n.settings-modal__label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 8px;\n}\n\nbody.light_theme .settings-modal__label {\n  color: #000000;\n}\n\n.settings-modal__input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.settings-modal__input {\n  width: 100%;\n  border: 0;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 14px 40px 14px 14px;\n  font-size: 14px;\n  color: #ffffff;\n  outline: none;\n}\n\nbody.light_theme .settings-modal__input {\n  background: #EDEEEF;\n  border: none;\n  color: #334155;\n}\n\n/* .settings-modal__input:focus {\n  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12);\n} */\n\n.settings-modal__input-clear {\n  position: absolute;\n  right: 10px;\n  border: 0;\n  background: none;\n  padding: 0;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  display: grid;\n  place-items: center;\n}\n\n.settings-modal__input-clear:hover {\n  color: #64748b;\n}\n\n.settings-modal__hint {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #999999;\n  line-height: 1.45;\n}\n\n.settings-modal__warn {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: #b45309;\n  background: #fffbeb;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.settings-modal__error {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: #b91c1c;\n}\n\n.settings-modal__btn {\n  border: 0;\n  border-radius: 999px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.05s ease;\n}\n\n.settings-modal__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.settings-modal__btn--muted {\n  width: 130px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal__btn--muted {\n  background: #DDDDDD;\n  color: #1e293b;\n}\n\n.settings-modal__btn--muted:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.15);\n}\n\nbody.light_theme .settings-modal__btn--muted:hover:not(:disabled) {\n  background: #d4d4d4;\n}\n\n.settings-modal__btn--primary {\n  flex: 1.15;\n  background: #303236;\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal__btn--primary {\n  background: #2d2e32;\n  color: #ffffff;\n}\n\n.settings-modal__btn--primary:hover:not(:disabled) {\n  background: #404246;\n}\n\nbody.light_theme .settings-modal__btn--primary:hover:not(:disabled) {\n  background: #1a1b1e;\n}\n\n.settings-modal__btn--wide {\n  flex: 1.25;\n}\n\n.settings-modal__info-banner {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n}\n\nbody.light_theme .settings-modal__info-banner {\n  background: #faf6ef;\n  border: none;\n}\n\n.settings-modal__info-banner p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #cbd5e1;\n}\n\nbody.light_theme .settings-modal__info-banner p {\n  color: #6b5f52;\n}\n\n.settings-modal__info-icon {\n  flex: 0 0 auto;\n  font-size: 18px;\n  color: #a89076;\n  margin-top: 1px;\n}\n\n.settings-modal__tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.settings-modal__tab {\n  border: 0;\n  border-radius: 999px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n}\n\n.settings-modal__tab.is-active {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal__tab.is-active {\n  background: #eef2f7;\n  color: #0f172a;\n}\n\n.settings-modal__avatar-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  padding: 4px 0 8px;\n}\n\n.settings-modal__avatar-cell {\n  aspect-ratio: 1;\n  border-radius: 999px;\n  border: 2px solid transparent;\n  padding: 0;\n  cursor: pointer;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.05);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\nbody.light_theme .settings-modal__avatar-cell {\n  background: #e2e8f0;\n}\n\n.settings-modal__avatar-cell img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.settings-modal__avatar-cell.is-selected {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.settings-modal__alerts-tabs {\n  display: flex;\n  gap: 32px;\n  border-bottom: 1px solid #e2e8f0;\n  margin: 4px 0 0;\n  padding: 0px 24px 3px;\n}\n\n.settings-modal__alerts-tab {\n  border: 0;\n  background: none;\n  padding: 10px 0 14px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #94a3b8;\n  cursor: pointer;\n  position: relative;\n}\n\nbody.light_theme .settings-modal__alerts-tab {\n  color: #6A7282;\n}\n\n.settings-modal__alerts-tab.is-active {\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal__alerts-tab.is-active {\n  color: #1a202c;\n}\n\n.settings-modal__alerts-tab.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -3px;\n  height: 3px;\n  border-radius: 999px;\n  background: #ffffff;\n}\n\nbody.light_theme .settings-modal__alerts-tab.is-active::after {\n  background: #1a202c;\n}\n\n.settings-modal__accordion {\n  margin-top: 12px;\n  padding: 0px 24px;\n}\n\n.settings-modal__acc-item {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.settings-modal__acc-head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 15px 10px;\n  border: 0;\n  background: none;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  cursor: pointer;\n  text-align: left;\n}\n\nbody.light_theme .settings-modal__acc-head {\n  color: #101828;\n}\n\n.settings-modal.settings-modal--wide.alert_setting {\n  height: auto;\n}\n\nheader ul.dropdown-menu li button.dropdown-item:active {\n  background-color: transparent;\n}\n\n.settings-modal__acc-head i {\n  font-size: 20px;\n  color: #718096;\n}\n\n.settings-modal__acc-body {\n  padding: 0 4px 12px;\n}\n\n.settings-modal__toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 10px 10px;\n  border-top: none;\n  font-size: 15px;\n}\n\n.settings-modal__toggle-row:first-child {\n  border-top: 0;\n}\n\n.settings-modal__switch {\n  width: 44px;\n  height: 24px;\n  border-radius: 999px;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.1);\n  transition: background 0.15s ease;\n}\n\nbody.light_theme .settings-modal__switch {\n  background: #e2e8f0;\n}\n\n.settings-modal__switch.is-on {\n  background: #10b981;\n}\n\nbody.light_theme .settings-modal__switch.is-on {\n  background: #1e293b;\n}\n\n.settings-modal__switch-knob {\n  position: absolute;\n  top: 2px;\n  left: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n  transition: transform 0.15s ease;\n}\n\n.settings-modal__switch.is-on .settings-modal__switch-knob {\n  transform: translateX(18px);\n}\n\n.settings-modal--lang {\n  width: min(100%, 520px);\n}\n\n.settings-modal__lang-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.settings-modal__lang-row {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.settings-modal__lang-row:last-child {\n  border-bottom: 0;\n}\n\n.settings-modal__lang-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #ffffff;\n}\n\nbody.light_theme .settings-modal__lang-label {\n  color: #334155;\n}\n\n.settings-modal__lang-label input {\n  accent-color: #0f172a;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* Settings: General / Identity tabs */\n.settings-page__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.settings-page__tab {\n  border: 1px solid #54555740;\n  color: #ffffff82;\n  background: #1e222a75;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\nbody.light_theme .settings-page__tab {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n}\n\n.settings-page__tab:hover {\n  color: #ffffff;\n  border-color: #54555740;\n}\n\n.settings-page__tab.is-active {\n  color: #ffffff;\n  background: #1e222a;\n  border-color: #54555740;\n}\n\nbody.light_theme .settings-page__tab.is-active {\n  color: #0f172a;\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.settings-page__pill--link {\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.settings-page__pill--link:hover {\n  color: #fff;\n}\n\n/* Identity tab — status + actions */\n.identity-section__row .identity-section__aside {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.identity-section__badge {\n  min-height: 37px;\n  padding: 4px 16px;\n  display: flex;\n  border-radius: 999px;\n  background: #f1f5f9;\n  white-space: nowrap;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.identity-section__badge--ok,\n.identity-section__badge--verified {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.identity-section__badge--pending,\n.identity-section__badge--under-review {\n  background: #fef3c7;\n  color: #a16207;\n}\n\n.identity-section__badge--in-progress {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.identity-section__badge--bad,\n.identity-section__badge--rejected {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.identity-section__badge--rekyc {\n  background: #f3e8ff;\n  color: #7e22ce;\n}\n\n.identity-section__badge--not-started {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n/* @media (max-width: 767.98px) {\n  .identity-section__row .identity-section__aside {\n    width: 100%;\n    justify-content: flex-start;\n  }\n} */\n\n\n@media (max-width: 1440px) {\n\n  .settings-page {\n    padding-right: 35px;\n  }\n\n  .settings-page__title {\n    font-size: 32px;\n  }\n\n\n}\n\n\n@media (max-width: 1200px) {\n\n  .settings-page {\n    padding-right: 10px;\n    padding-left: 20px;\n  }\n\n  .settings-modal--avatar .settings-modal__title {\n    font-size: 24px;\n  }\n\n}\n\n\n@media (max-width: 991px) {\n\n  .settings-page {\n    padding-right: 0px;\n    padding-left: 0px;\n  }\n\n  body.light_theme .settings-page__card {\n    border: none;\n  }\n\n  .settings-page__title {\n    font-size: 24px;\n  }\n\n  .settings-page__card-title {\n    font-size: 20px;\n  }\n\n  .settings-page__row-title {\n    font-size: 16px;\n  }\n\n  .settings-page__card-head {\n    padding: 5px 0px;\n    border-bottom: none;\n  }\n\n  .settings-page__card {\n    border: none;\n    background: none;\n    border-radius: 0px;\n    box-shadow: none;\n    padding: 0px;\n    border-bottom: 1px solid #eeeeee21;\n    margin-bottom: 20px;\n  }\n\n  body.light_theme .settings-page__card {\n    border-bottom: 1px solid #eeeeee;\n  }\n\n  .settings-page__row {\n    padding: 14px 0px;\n    border-bottom: none;\n  }\n\n  .settings-page__row-text {\n    display: none;\n  }\n\n  .settings-page__card-desc {\n    display: none;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .settings-page__title {\n    font-size: 22px;\n  }\n\n  .settings-modal--nickname {\n    width: 100%;\n  }\n\n  .settings-modal__avatar-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .settings-modal--avatar .settings-modal__avatar-cell {\n    width: 60px;\n    height: 60px;\n  }\n\n  .settings-modal--avatar .settings-modal__btn {\n    padding: 8px 18px;\n    font-size: 13px;\n  }\n\n  .d-flex.profilebl_s {\n    width: 100%;\n  }\n\n  .settings-modal {\n    height: min(100%, 65%);\n  }\n\n  .settings-modal__accordion {\n    margin-top: 5px;\n    padding: 0px 15px;\n  }\n\n  .settings-modal__switch {\n    width: 38px;\n    height: 20px;\n  }\n\n  .settings-modal__switch-knob {\n    width: 16px;\n    height: 16px;\n  }\n\n  .settings-modal__acc-head {\n    font-size: 14px;\n  }\n\n  .settings-modal.settings-modal--wide.alert_setting {\n    height: min(100%, 65%);\n  }\n\n  .settings-modal--avatar .settings-modal__title {\n    font-size: 20px;\n  }\n\n  .settings-page__icon {\n    display: none;\n  }\n\n  .settings-modal-overlay {\n    padding: 0px;\n    align-items: end;\n  }\n\n  .settings-modal {\n    border-radius: 18px 18px 0px 0px;\n    width: 100%;\n  }\n\n  .settings-modal.settings-modal--avatar {\n    width: 100%;\n  }\n\n  .settings-modal__title {\n    font-size: 20px;\n  }\n\n  .settings-modal__label {\n    font-size: 14px;\n  }\n\n}\n\n@media (max-width: 580px) {\n\n  .identity-section__badge {\n    min-height: 34px;\n    padding: 4px 12px;\n    font-size: 12px;\n  }\n\n  .settings-page__pill {\n    padding: 7px 12px;\n    min-height: 34px;\n    font-size: 12px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
